import React, { useState, useEffect } from "react";
import img from "../Images/default.png";
import "../CSS/about.css";
import Navbar from "../COMPONENT/Navbar/Navbar";
import Footer from "../COMPONENT/Footer/Footer";
import Loader from "../COMPONENT/Loader";
import Notfound from "./NotFound";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setProducts, setURL } from "../store/storeDataSlice";
import axios from "axios";

function About() {
  const { name } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isLinkExist, setIsLinkExist] = useState(false);
  const { data } = useSelector((state) => state.product);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_API}/get-store`,
          { businessLink: name }
        );
        setLoading(false);
        if (response.data.message === "Invalid URL") {
          setIsLinkExist(false);
        } else if (response.data.message === "Valid URL") {
          setIsLinkExist(true);
          dispatch(setProducts(response.data.data));
          dispatch(setURL(name));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [name, dispatch]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {isLinkExist ? (
            <div>
              <Navbar />
              <div className="container">
                <header>
                  <h1>About Us</h1>
                </header>
                <div className="about-content">
                  <div className="about-text">
                    <h1>Welcome to {data.businessName}</h1>
                    <p>
                      {data.storeDetails &&
                      data.storeDetails[0].businessDescription
                        ? data.storeDetails[0].businessDescription
                        : ""}
                    </p>
                    <p>Thank you for being a part of our journey.</p>
                    <p className="signature">- The {data.businessName} Team</p>
                  </div>
                  <div className="about-image">
                    <img
                      src={
                        data.storeDetails && data.storeDetails[0].logo
                          ? `${process.env.REACT_APP_LOGO_IMAGE_PATH}${data.storeDetails[0].logo}`
                          : img
                      }
                      alt="store-logo"
                    />
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          ) : (
            <Notfound />
          )}
        </>
      )}
    </>
  );
}

export default About;
